/* eslint-disable @typescript-eslint/no-explicit-any */
import _includes from 'lodash/includes';
import { STRINGS } from '../../config';
import { AppState } from '../../model/State';

const { RESET_ALL_STATE, SET_PRACTICE, SET_USER_DATA, SET_EDITING_SUMMARY } = STRINGS.REDUCERS.APP;

const { CONNECTION_CLOSE, CONNECTION_OPEN } = STRINGS.REDUCERS.WEBSOCKET;

const {
  USER: {
    ROLE: { CLINICAL_SYSTEM_S1, CLINICAL_SYSTEM_EMIS },
  },
  INTEROP: { USER_ROLE_TO_INTEROP_NAME },
} = STRINGS;

export const initialAppState: AppState = {
  selectedPractice: null,
  selectedPracticeIsEhub: null,
  user: {
    practices: [],
    ehubs: [],
    adminRights: [],
    currentUserEmail: null,
    currentUserName: null,
    name: '',
    summariserIds: [],
  },
  roles: [],
  clinicalSystemName: null,
  isEditingSummary: false,
  isRecordingConnectionOpen: false,
};

// const checkForInitialAdminRights = (payload: any) => {
//   const userIsAdminOfFirstListedPractice = payload?.adminRights?.includes(payload?.practices[0]?.id);
//   const eHubOnlyUserIsAdminOfFirstListedEhub = (!payload?.practices[0] && payload?.adminRights?.includes(payload?.ehubs[0]?.id));
//   return userIsAdminOfFirstListedPractice || eHubOnlyUserIsAdminOfFirstListedEhub;
// };

type UserRole = keyof typeof USER_ROLE_TO_INTEROP_NAME;

const getInteropSystemName = (userRoles: UserRole[]): string | null => {
  const clinicalSystemUserRole = userRoles?.find(role =>
    _includes([CLINICAL_SYSTEM_S1, CLINICAL_SYSTEM_EMIS], role),
  ) as UserRole | undefined;
  return clinicalSystemUserRole ? USER_ROLE_TO_INTEROP_NAME[clinicalSystemUserRole] : null;
};

export const appReducer = (state: any, action: any) => {
  switch (action.type) {
    case RESET_ALL_STATE: {
      return {
        ...initialAppState,
      };
    }
    case SET_PRACTICE: {
      return {
        ...state,
        // selectedPractice: action.payload.practice,
        // selectedPracticeIsEhub: action.payload.isEhub,
      };
    }
    case SET_USER_DATA: {
      // const userHasOnlyEhubsAndNoPractices = !!(!action.payload?.practices[0] && action.payload?.ehubs);
      const clinicalSystemName = getInteropSystemName(action.payload?.roles);
      return {
        ...state,
        selectedPractice: action.payload.selectedPractice,
        roles: action.payload.roles,
        // selectedPracticeIsEhub: userHasOnlyEhubsAndNoPractices,
        user: action.payload,
        clinicalSystemName,
      };
    }
    case SET_EDITING_SUMMARY: {
      return {
        ...state,
        isEditingSummary: action.payload,
      };
    }
    case CONNECTION_CLOSE: {
      return {
        ...state,
        isRecordingConnectionOpen: false,
      };
    }
    case CONNECTION_OPEN: {
      return {
        ...state,
        isRecordingConnectionOpen: true,
      };
    }
    default: {
      return state;
    }
  }
};
